import { APP_CHAT_MANAGER_API_URL } from "../../config";
import type { AraUserProfile } from "./models";

const _MOCK_SUBSCRIBER: AraUserProfile = {
  userId: 123,
  name: "Usuario Suscriptor",
  nick: "usuario_suscriptor",
  email: "subscriber@test.com",
  subscriber: true,
  avatarUrl:
    "https://ui-avatars.com/api/?name=US&background=0076A8&color=FFFFFF&size=40",
  emailValidated: true,
  language: "es"
};

const _MOCK_NON_SUBSCRIBER: AraUserProfile = {
  userId: 456,
  name: "Usuario NO Suscriptor",
  nick: "usuario_normal",
  email: "nonsubscriber@test.com",
  subscriber: false,
  avatarUrl:
    "https://static1.ara.cat/ara/public/user/avatar/2022/0913/10/apple-icon-152x152-png-afd03cd.png",
  emailValidated: true,
  language: "es"
};

export const fetchUserProfile = async (): Promise<AraUserProfile> => {
  if (import.meta.env.VITE_MOCK_API === "true") {
    // CASO A: Simular un usuario que SÍ es suscriptor
    return _MOCK_SUBSCRIBER;

    // CASO B: Simular un usuario que NO es suscriptor
    //return _MOCK_NON_SUBSCRIBER;

    // CASO C: Simular que el usuario NO está logueado (esto provocará la redirección)
    // throw new Error("Mock: Usuario no autenticado");
  }

  const response = await fetch(
    `${APP_CHAT_MANAGER_API_URL}/agenda-cultural-ara-api/v1/user/profile`,
    {
      method: "GET",
      credentials: "include" // Para que el navegador/WebView envíe cookies automáticamente
    }
  );

  if (!response.ok) {
    throw new Error("Usuario no autenticado");
  }

  const data: AraUserProfile = await response.json();
  return data;
};

/**
 * Llama al endpoint oficial de ARA para cerrar sesión
 * Esto borrará las cookies de sesión (incluyendo HttpOnly)
 */
export const logoutFromARA = async (): Promise<void> => {
  try {
    await fetch("https://www.ara.cat/api/front/user/logout", {
      method: "POST",
      credentials: "include", // Para que el navegador envíe las cookies automáticamente
      headers: {
        Accept: "application/json, text/plain, */*"
      }
    });
  } catch (error) {
    // Ignorar errores, seguimos con el logout de todas formas
    console.error("Error calling ARA logout endpoint:", error);
  }
};
